module.exports = __webpack_public_path__ + "img/rea1.729487e1.png";